import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetOtherExpenseDetailsQuery } from '../slices/otherExpensesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import OtherExpenseCarousel from '../components/OtherExpenseCarousel';

const OtherExpenseStaffScreen = () => {
  const { id: otherExpenseId } = useParams();
  const { data: otherExpense, isLoading, error } = useGetOtherExpenseDetailsQuery(otherExpenseId);

  const renderOtherExpenseDetails = () => (
    <>
      <Meta title={otherExpense.date} description={otherExpense.account} />
      <Row>
        <Col md={6}>
          {/* Display otherExpense images using OtherExpenseCarousel */}
          {otherExpense.images && otherExpense.images.length > 0 ? (
            <OtherExpenseCarousel images={otherExpense.images} />
          ) : (
            <Message variant="info">No images available for this otherExpense</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{otherExpense.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {otherExpense.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {otherExpense.amount}</ListGroup.Item>
            <ListGroup.Item>
              Category: {otherExpense.category}
            </ListGroup.Item>
            <ListGroup.Item>Notes:{otherExpense.notes}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{otherExpense.amount}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {otherExpense.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="otherExpense-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {otherExpense.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to='/otherExpenselist'>
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderOtherExpenseDetails()
      )}
    </>
  );
};

export default OtherExpenseStaffScreen;